import { render, staticRenderFns } from "./RegistrationConfirmed.vue?vue&type=template&id=23ee1072&scoped=true"
import script from "./RegistrationConfirmed.vue?vue&type=script&lang=js"
export * from "./RegistrationConfirmed.vue?vue&type=script&lang=js"
import style0 from "./RegistrationConfirmed.vue?vue&type=style&index=0&id=23ee1072&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ee1072",
  null
  
)

export default component.exports